import { render, staticRenderFns } from "./ClasseRiscoForm.vue?vue&type=template&id=529ea166"
import script from "./ClasseRiscoForm.vue?vue&type=script&lang=js"
export * from "./ClasseRiscoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports